import React, { useState, useRef, useEffect } from 'react';
import {
    AppBar,
    Toolbar,
    Typography,
    Button,
    ButtonGroup,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Tabs,
    Tab,
    Divider,
    Popover,
    IconButton,
    Alert,
    Snackbar,
    Modal,
    Grid
} from '@mui/material';
import {
    FormatBold,
    FormatItalic,
    FormatUnderlined,
    FormatAlignLeft,
    FormatAlignCenter,
    FormatAlignRight,
    FormatAlignJustify,
    FormatListBulleted,
    FormatListNumbered,
    Undo,
    Redo,
    Save,
    BorderColor,
    FormatColorText,
    FormatColorFill,
    InsertPhoto,
    TableChart,
    PictureAsPdf,
    Settings,
    GridOn,
    TextFields,
    FormatSize,
    FormatPaint,
    BorderAll,
    BorderClear,
    BorderOuter,
    Close,
    Upload
} from '@mui/icons-material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import RotateLeftOutlinedIcon from '@mui/icons-material/RotateLeftOutlined';
// import { FaParagraph, FaFont, FaPalette } from 'react-icons/fa';
// import { MdFormatColorReset, MdPageview, MdLandscape, MdPortrait } from 'react-icons/md';
import { ChromePicker } from 'react-color';
import axios from 'axios';
import printApi from '../../../../../../services/managelicense/index';
import { useDispatch } from 'react-redux';
import { showLoader, hideLoader } from '../../../../../../redux/loader/actions';
import { showSnackbar } from '../../../../../../redux/snackbar/actions';
import { getDecryptedCookie } from '../../../../../../utils';
import { useNavigate, useParams } from 'react-router-dom';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function App({
    open,
    onClose,
    side,
    licenceUid,
    paperType,
    officeCopy,
    businessuuid,
    textColorStyle,
    tempImg,
    firstCanvasRef,
    license,
    secondCanvasRef,
    preview,
    color,
    uploadedImage,
    billpreviewbusinessuuid,
    setBillPreviewBusinessuuid,
    licenseuuid,
    businesssid,
    setLicenseUuid,
    edit,
    handleEditClick,
    index,
    setLanguageType,
    languageType,
    editableIndex
}) {
    const dispatch = useDispatch();
    const editorRef = useRef(null);
    const fileInputRef = useRef(null);
    const [fontFamily, setFontFamily] = useState('Times New Roman');
    const [fontSize, setFontSize] = useState('12');
    const [isBold, setIsBold] = useState(false);
    const [isItalic, setIsItalic] = useState(false);
    const [isUnderline, setIsUnderline] = useState(false);
    const [alignment, setAlignment] = useState('left');
    const [textColor, setTextColor] = useState();
    const [highlightColor, setHighlightColor] = useState();

    const [pageOrientation, setPageOrientation] = useState(
        paperType === 'customer_with_item_image_article_type1' || paperType === 'customer_with_item_image_article_type2'
            ? 'portrait'
            : 'landscape'
    );
    const [showTableDialog, setShowTableDialog] = useState(false);
    const [rows, setRows] = useState(3);
    const [cols, setCols] = useState(3);
    const [activeTab, setActiveTab] = useState(0);
    const [showPageSetup, setShowPageSetup] = useState(false);
    const [pageMargins, setPageMargins] = useState({
        top: '10px',
        right: '10px',
        bottom: '10px',
        left: '15px'
    });
    const [colorPickerAnchor, setColorPickerAnchor] = useState(null);
    const [currentColorType, setCurrentColorType] = useState(null);
    const [tableBorder, setTableBorder] = useState('1');
    const [overflowAlert, setOverflowAlert] = useState(false);
    const [openAlertDialog, setOpenAlertDialog] = useState(false);

    const productUid = getDecryptedCookie('proid');
    const BusinessId = getDecryptedCookie('print');
    const licenceId = licenceUid;
    const handleDialogClose = () => {
        setOpenAlertDialog(false);
    };
    const handleDialogOpen = () => {
        setOpenAlertDialog(true);
    };
    const handleResetConfirm = () => {
        processImportedContent(reset);
        setOpenAlertDialog(false);
    };

    const fonts = [
        'Times New Roman',
        'Arial',
        // 'Calibri',
        'Quicksand',
        // 'Nunito',
        'Pavanam'
        // 'Verdana',
        // 'Courier New',
        // 'Georgia',
        // 'Comic Sans MS',
        // 'Cambria',
        // 'Tahoma'
    ];

    const fontSizes = ['8', '10', '12', '14', '16', '18', '20', '24', '28', '32', '36', '48', '72'];

    // A4 dimensions in pixels (at 96dpi)
    const a4WidthPx = 1030; // 210mm at 96dpi 794 1015
    const a4HeightPx = 1300; // 297mm at 96dpi 1123

    const checkOverflow = () => {
        if (!editorRef.current) return;

        const editor = editorRef.current;
        // const pageWidth = pageOrientation === 'portrait' ? a4WidthPx : a4HeightPx;
        // const pageHeight = pageOrientation === 'portrait' ? a4HeightPx : a4WidthPx;

        const pageWidth = pageOrientation === 'portrait' ? a4WidthPx : a4HeightPx;
        const pageHeight =
            pageOrientation === 'landscape' && isSaved === false && isPreview === false && side !== 'back'
                ? 900
                : pageOrientation === 'portrait'
                ? a4HeightPx
                : a4WidthPx;

        // Get the actual content dimensions
        const contentWidth = editor.scrollWidth;
        const contentHeight = editor.scrollHeight;

        // Calculate available space (accounting for margins)
        const topMargin = parseInt(pageMargins.top) || 0;
        const bottomMargin = parseInt(pageMargins.bottom) || 0;
        const leftMargin = parseInt(pageMargins.left) || 0;
        const rightMargin = parseInt(pageMargins.right) || 0;

        const availableWidth = pageWidth - leftMargin - rightMargin;
        const availableHeight = pageHeight - topMargin - bottomMargin;

        // Check if content exceeds available space
        const isOverflowing = contentHeight > availableHeight || contentWidth > availableWidth;

        if (isOverflowing !== overflowAlert) {
            setOverflowAlert(isOverflowing);
        }
    };

    const toggleFormat = (format, value = null) => {
        document.execCommand(format, false, value);
        switch (format) {
            case 'bold':
                setIsBold(!isBold);
                break;
            case 'italic':
                setIsItalic(!isItalic);
                break;
            case 'underline':
                setIsUnderline(!isUnderline);
                break;
            case 'foreColor':
                setTextColor(value);
                break;
            case 'hiliteColor':
                setHighlightColor(value);
                break;
            default:
                break;
        }
        setTimeout(checkOverflow, 0); // Check overflow after format change
    };

    const setTextAlignment = (align) => {
        document.execCommand('formatBlock', false, '<div>');
        document.execCommand('justify' + align, false, null);
        setAlignment(align);
        setTimeout(checkOverflow, 0);
    };

    const handleFontChange = (e) => {
        const font = e.target.value;
        setFontFamily(font);
        document.execCommand('fontName', false, font);
        setTimeout(checkOverflow, 0);
    };

    const handleFontSizeChange = (e) => {
        const size = e.target.value;
        setFontSize(size);

        // Map pixel sizes to HTML font sizes (1-7)
        const htmlSizes = {
            8: '1',
            10: '2',
            12: '3',
            14: '4',
            16: '5',
            18: '6',
            20: '7',
            24: '7',
            28: '7',
            32: '7',
            36: '7',
            48: '7',
            72: '7'
        };

        // document.execCommand('fontSize', false, htmlSizes[size] || '3');

        // // For better control, we'll also set the actual size via inline style
        // document.execCommand('formatBlock', false, '<span>');
        // document.execCommand('styleWithCSS', false, true);
        // document.execCommand('fontSize', false, '1'); // Reset to smallest
        document.execCommand(
            'insertHTML',
            false,
            `<span style="font-size: ${size}px">${window.getSelection().toString()}</span>`
        );

        setTimeout(checkOverflow, 0);
    };

    const createList = (type) => {
        document.execCommand(type === 'bullet' ? 'insertUnorderedList' : 'insertOrderedList');
        setTimeout(checkOverflow, 0);
    };

    const [fieldUsage, setFieldUsage] = useState({});

    const processImportedContent = (content, isPreview = false) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = content;

        const usageCount = {};
        fieldOptions.forEach((option) => {
            const variablePattern = new RegExp(`\\{\\{?${option.value}\\}?\\}`, 'g');
            const matches = content?.match(variablePattern);
            usageCount[option.value] = matches ? matches.length : 0;
        });

        setFieldUsage(usageCount);
        if (!isPreview) {
            const images = tempDiv.querySelectorAll('img');
            images.forEach((img) => {
                if (img.alt === 'Logo') {
                    img.src = 'https://th.bing.com/th/id/OIP.rnxRsteNhrBigNjjHOQDagAAAA?rs=1&pid=ImgDetMain';
                } else if (img.alt === 'QR Img') {
                    img.src =
                        'https://www.researchgate.net/publication/340398294/figure/fig3/AS:876175308103681@1585907880294/Sample-Figure-of-QR-Code-QR-code-works-in-a-simple-way-It-all-starts-of-by-feeding-in.ppm';
                } else if (img.alt === 'Customer Img') {
                    img.src =
                        'https://static.vecteezy.com/system/resources/previews/005/544/718/non_2x/profile-icon-design-free-vector.jpg';
                } else if (img.alt === 'Item Img1') {
                    img.src =
                        'https://tagtes-s3-b02.s3.ap-south-1.amazonaws.com/product/75001PBA/dev/e6b5a82e-05dc-40c3-b0ae-bdb6cf06c3cf.jpeg';
                } else if (img.alt === 'Item Img2') {
                    img.src =
                        'https://tagtes-s3-b02.s3.ap-south-1.amazonaws.com/product/75001PBA/dev/115ba403-d08f-41ec-9743-07ddcf5457e8.jpeg';
                } else if (img.alt === 'Item Img3') {
                    img.src =
                        'https://tagtes-s3-b02.s3.ap-south-1.amazonaws.com/product/75001PBA/dev/c70472d5-6a92-41d1-8623-cc6e4c31bfa6.jpeg';
                }
            });
        }

        // Remove color-related styles from style tags
        const styleTags = tempDiv.querySelectorAll('style');
        styleTags.forEach((tag) => {
            tag.textContent = tag.textContent;
            // .replace(/color:[^;"]*;?/g, '')
            // .replace(/background-color:[^;"]*;?/g, '')
            // .replace(/background:[^;"]*;?/g, '')
            // .replace(/fill:[^;"]*;?/g, '')
            // .replace(/stroke:[^;"]*;?/g, '');
        });

        // Remove color-related inline styles from all elements
        const allElements = tempDiv.querySelectorAll('*');
        allElements.forEach((el) => {
            el.style.color = '';
            el.style.backgroundColor = '';
            el.style.background = '';
            el.style.fill = '';
            el.style.stroke = '';
        });

        // Convert template variables to display format
        fieldOptions.forEach((option) => {
            const variablePattern = new RegExp(`\\{\\{?${option.value}\\}?\\}`, 'g');
            const elementsWithText = tempDiv.querySelectorAll('*:not(script):not(style)');

            elementsWithText.forEach((el) => {
                // Skip IMG elements and their parents
                // if (el.tagName === 'IMG' || el.closest('img')) {
                //     return;
                // }

                // Only process elements with direct text nodes
                const hasDirectText = Array.from(el.childNodes).some(
                    (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== ''
                );

                if (hasDirectText) {
                    el.innerHTML = el.innerHTML.replace(
                        variablePattern,
                        `<span contenteditable="true">${option.display}</span>`
                    );
                }
            });
        });

        // Get the body content or use the entire content
        const bodyContent = tempDiv.querySelector('body')?.innerHTML || tempDiv.innerHTML;

        if (editorRef.current) {
            editorRef.current.innerHTML = bodyContent;
            setFieldUsage(countFieldUsage()); // Count fields after import
            setTimeout(checkOverflow, 0);
        }
    };

    const handleSave = () => {
        dispatch(showLoader());
        let content = editorRef.current.innerHTML;

        const images = Array.from(new DOMParser().parseFromString(content, 'text/html').querySelectorAll('img'));
        images.forEach((img) => {
            if (img.alt === 'Logo') {
                content = content.replace(
                    img.outerHTML,
                    `<img src="{{bill_file_id}}" alt="Logo" style="${img.style.cssText}"/>`
                );
            } else if (img.alt === 'QR Img') {
                content = content.replace(
                    img.outerHTML,
                    `<img src="{{qr_file_url}}" alt="QR Img" style="${img.style.cssText}"/>`
                );
            } else if (img.alt === 'Customer Img') {
                content = content.replace(
                    img.outerHTML,
                    `<img src="{{customer_logo}}" alt="Customer Img" style="${img.style.cssText}"/>`
                );
            } else if (img.alt === 'Item Img1') {
                content = content.replace(
                    img.outerHTML,
                    `<img src="{{loan_item1}}" alt="Item Img1" style="${img.style.cssText}"/>`
                );
            } else if (img.alt === 'Item Img2') {
                content = content.replace(
                    img.outerHTML,
                    `<img src="{{loan_item2}}" alt="Item Img2" style="${img.style.cssText}"/>`
                );
            } else if (img.alt === 'Item Img3') {
                content = content.replace(
                    img.outerHTML,
                    `<img src="{{loan_item3}}" alt="Item Img3" style="${img.style.cssText}"/>`
                );
            }
        });

        fieldOptions.forEach((option) => {
            content = content.replace(new RegExp(option.display, 'g'), `{{${option.value}}}`);
        });

        const fullContent = `
    <!DOCTYPE html>
    <html>
    <head>
      ${content}
    </html>
  `;
        const encodedContent = encodeURIComponent(fullContent);
        const Postdata = {
            mast_template_id: templateUid,
            license_id: licenceId,
            business_id: BusinessId,
            bus_template_content: encodedContent
        };
        const Updatedata = {
            bus_template_content: encodedContent
        };

        const onSuccess = (res) => {
            dispatch(hideLoader());
            if (res?.data?.data?.status) {
                const transformedOptions =
                    res.data.data?.varibles_allowed?.map((item) => ({
                        display: item.label.toString(),
                        value: item.variable.toString(),
                        times: item.iteration.toString()
                    })) || [];
                setTemplateUid(res?.data?.res?.data?.uuid);
                // setOriginalContent(fullContent);
                setIsSaved(true);
                setIsPreview(true);
                handlePreview();
            }
        };

        const onFailure = (err) => {
            dispatch(hideLoader());
            console.log(err);
            dispatch(
                showSnackbar({
                    message: err?.response?.data?.res?.message,
                    autoHideDuration: 3000,
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    variant: 'error'
                })
            );
        };

        customizedTempId
            ? printApi.updatePrint(productUid, customizedTempId, Updatedata).then(onSuccess).catch(onFailure)
            : printApi.postPrint(productUid, Postdata).then(onSuccess).catch(onFailure);
    };

    const resetFormatting = () => {
        document.execCommand('removeFormat', false, null);
        setIsBold(false);
        setIsItalic(false);
        setIsUnderline(false);
        setTextColor('#000000');
        setHighlightColor('#ffffff');
        setAlignment('left');
        setTimeout(checkOverflow, 0);
    };

    const toggleOrientation = () => {
        setPageOrientation((prev) => (prev === 'portrait' ? 'landscape' : 'portrait'));
        setTimeout(checkOverflow, 0);
    };

    const openColorPicker = (type, event) => {
        setCurrentColorType(type);
        setColorPickerAnchor(event.currentTarget);
    };

    const closeColorPicker = () => {
        setColorPickerAnchor(null);
        setCurrentColorType(null);
    };

    const handleColorChange = (color) => {
        const hexColor = color.hex;
        if (currentColorType === 'text') {
            setTextColor(hexColor);
            toggleFormat('foreColor', hexColor);
        } else if (currentColorType === 'highlight') {
            setHighlightColor(hexColor);
            toggleFormat('hiliteColor', hexColor);
        }
    };

    // Keep your existing handleImport for file uploads (if still needed)
    const handleImport = (event) => {
        setPageOrientation('portrait');
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            const content = e.target.result;
            processImportedContent(content);
        };
        reader.readAsText(file);
        event.target.value = '';
    };
    const triggerFileInput = () => {
        fileInputRef.current.click();
    };

    const protectTemplateFields = () => {
        if (!editorRef.current) return;

        // Convert all template fields to spans with special attributes
        fieldOptions.forEach((option) => {
            // Handle both the display format and raw {{variable}} format
            const elements = editorRef.current.querySelectorAll(`[data-variable="${option.value}"]`);

            elements.forEach((el) => {
                // Make sure the content remains unchanged
                if (el.textContent !== option.display) {
                    el.textContent = option.display;
                }
                // Ensure it's not editable
                el.contentEditable = 'true';
                // Ensure the styling is maintained
            });

            // Also find any raw {{variable}} that might have been inserted manually
            const variablePattern = new RegExp(`\\{\\{?${option.value}\\}?\\}`, 'g');
            const textNodes = [];

            const walker = document.createTreeWalker(editorRef.current, NodeFilter.SHOW_TEXT, null, false);

            let node;
            while ((node = walker.nextNode())) {
                if (variablePattern.test(node.nodeValue)) {
                    textNodes.push(node);
                }
            }

            textNodes.forEach((textNode) => {
                const span = document.createElement('span');
                span.dataset.variable = option.value;
                span.contentEditable = 'true';
                span.textContent = option.display;

                textNode.parentNode.replaceChild(span, textNode);
            });
        });
    };

    const countFieldUsage = () => {
        if (!editorRef.current) return {};

        const counts = {};
        fieldOptions.forEach((option) => {
            const elements = editorRef.current.querySelectorAll(`[data-variable="${option.value}"]`);
            counts[option.value] = elements.length;
        });

        return counts;
    };
    // Handle content changes in the editor
    const handleEditorChange = () => {
        protectTemplateFields();
        setIsSaved(false);
        setFieldUsage(countFieldUsage()); // Update counts on any change
        setTimeout(checkOverflow, 0);
    };

    useEffect(() => {
        if (editorRef.current) {
            // editorRef.current.focus();
            setFieldUsage(countFieldUsage());
            // Add event listeners for content changes
            editorRef.current.addEventListener('input', handleEditorChange);
            editorRef.current.addEventListener('paste', handleEditorChange);
            editorRef.current.addEventListener('cut', handleEditorChange);

            return () => {
                if (editorRef.current) {
                    editorRef.current.removeEventListener('input', handleEditorChange);
                    editorRef.current.removeEventListener('paste', handleEditorChange);
                    editorRef.current.removeEventListener('cut', handleEditorChange);
                }
            };
        }
    }, [open, handleEditorChange]);

    // Check overflow when page settings change
    useEffect(() => {
        checkOverflow();
    }, [pageOrientation, pageMargins]);

    useEffect(() => {
        setPageOrientation(
            paperType === 'customer_with_item_image_article_type1' ||
                paperType === 'customer_with_item_image_article_type2'
                ? 'portrait'
                : 'landscape'
        );
    }, [paperType]);

    const [reset, setReset] = useState(true);
    const [templateUid, setTemplateUid] = useState();
    const [customizedTempId, setCustomizedTempId] = useState();
    const [isPreview, setIsPreview] = useState(true);
    const [originalContent, setOriginalContent] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [billType, setBillType] = useState('');
    const fetchTemplate = () => {
        dispatch(showLoader());
        const onSuccess = (res) => {
            dispatch(hideLoader());
            if (res?.data?.status === true) {
                const transformedOptions =
                    res.data.data?.varibles_allowed?.map((item) => ({
                        display: item.label.toString(),
                        value: item.variable.toString(),
                        times: item.iteration.toString()
                    })) || [];

                // setInitialContent(res?.data?.data?.bus_content)
                setBillType(res?.data?.data?.data?.bill_type);
                setCustomizedTempId(res?.data?.data?.data?.bus_template_uuid);
                setTemplateUid(res?.data?.data?.data?.mast_template_uuid);
                const mastContent = res?.data?.data?.data?.mast_content;
                const businessContent = res?.data?.data?.data?.bus_content;
                const initialContent = businessContent ? businessContent : mastContent;
                setReset(mastContent);
                processImportedContent(initialContent);
                // setOriginalContent(initialContent);
                setIsPreview(false);
                // setFieldOptions(transformedOptions);
            }
        };
        const onFailure = (err) => {
            dispatch(hideLoader());
            dispatch(
                showSnackbar({
                    message: 'Content Not Available',
                    autoHideDuration: 3000,
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    variant: 'error'
                })
            );
        };
        printApi
            .getPrint(
                productUid,
                side === 'back' ? 'loan_print_backside' : 'loan_print_frontside',
                licenceId,
                null,
                (paperType === 'customer_with_item_image_article_type1' && !officeCopy) ||
                    (paperType === 'customer_with_item_image_article_type2' && !officeCopy)
                    ? 'customer_copy'
                    : (paperType === 'customer_with_item_image_article_type1' && officeCopy) ||
                      (paperType === 'customer_with_item_image_article_type2' && officeCopy)
                    ? 'office_copy'
                    : null
            )
            .then(onSuccess)
            .catch(onFailure);
    };

    const handlePreview = () => {
        // if (isPreview) {
        //   // Switch back to edit mode
        //   processImportedContent(originalContent);
        //   setIsPreview(false);
        // } else {
        // Switch to preview mode
        dispatch(showLoader());
        const onSuccess = (res) => {
            dispatch(hideLoader());
            setBillType(res?.data?.data?.bill_type);
            if (res?.data?.status === true) {
                const previewContent = res?.data?.data?.data;
                // setBillType(res?.data?.data);

                processImportedContent(previewContent, true);
                setIsPreview(true);
            }
        };
        const onFailure = (err) => {
            dispatch(hideLoader());
            dispatch(
                showSnackbar({
                    message: 'Content Not Available',
                    autoHideDuration: 3000,
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    variant: 'error'
                })
            );
        };
        printApi
            .getPrint(
                productUid,
                side === 'back' ? 'loan_print_backside' : 'loan_print_frontside',
                licenceId,
                true,
                (paperType === 'customer_with_item_image_article_type1' && !officeCopy) ||
                    (paperType === 'customer_with_item_image_article_type2' && !officeCopy)
                    ? 'customer_copy'
                    : (paperType === 'customer_with_item_image_article_type1' && officeCopy) ||
                      (paperType === 'customer_with_item_image_article_type2' && officeCopy)
                    ? 'office_copy'
                    : null
            )
            .then(onSuccess)
            .catch(onFailure);
        // }
    };
    useEffect(() => {
        if (open) {
            handlePreview();
        }
    }, [open]);

    // useEffect(() => {
    //   const fetchTemplate = async () => {
    //     try {
    //       const response = await axios.get(
    //         'http://next.tagcs.net/pba75001py_store_config/pba_mast_template/services/get-mast-template/797e09bf-2536-40fe-a268-c5994678e7bc'
    //       );

    //       if (response.data.status && response.data.data?.template_content) {
    //         processImportedContent(response.data.data.template_content);
    //         console.log("first", response.data.data.template_content)
    //       } else {
    //         console.error('Failed to load template from API');
    //         // Set default content if API fails
    //         if (editorRef.current) {
    //           editorRef.current.innerHTML = '<p>Start typing here...</p>';
    //         }
    //       }
    //     } catch (error) {
    //       console.error('Error fetching template:', error);
    //       // Set default content if API fails
    //       if (editorRef.current) {
    //         editorRef.current.innerHTML = '<p>Start typing here...</p>';
    //       }
    //     } finally {
    //       setIsLoading(false);
    //     }
    //   };

    //   fetchTemplate();
    // }, []);

    // Add this function to insert a table
    const insertTable = () => {
        let tableHTML = `<table border="${tableBorder}" style="width:100%; border-collapse:collapse; margin: 10px 0;" contenteditable="true">`;
        for (let i = 0; i < rows; i++) {
            tableHTML += '<tr>';
            for (let j = 0; j < cols; j++) {
                tableHTML += `<td style="padding:8px; border:${tableBorder}px solid #000;">&nbsp;</td>`;
            }
            tableHTML += '</tr>';
        }
        tableHTML += '</table>';

        document.execCommand('insertHTML', false, tableHTML);
        setShowTableDialog(false);
        setTimeout(() => {
            makeTablesResizable();
            makeTablesDraggable();
        }, 100);
    };

    // Add these helper functions for resizable and draggable tables
    const makeTablesResizable = () => {
        const tables = editorRef.current.querySelectorAll('table');
        tables.forEach((table) => {
            table.style.resize = 'both';
            table.style.overflow = 'auto';
        });
    };

    const makeTablesDraggable = () => {
        const tables = editorRef.current.querySelectorAll('table');
        tables.forEach((table) => {
            table.draggable = true;
            table.addEventListener('dragstart', (e) => {
                e.dataTransfer.setData('text/plain', 'table');
                e.target.classList.add('dragging');
            });

            table.addEventListener('dragend', (e) => {
                e.target.classList.remove('dragging');
            });
        });

        editorRef.current.addEventListener('dragover', (e) => {
            e.preventDefault();
        });

        editorRef.current.addEventListener('drop', (e) => {
            e.preventDefault();
            const draggedTable = document.querySelector('.dragging');
            if (draggedTable) {
                const range = document.caretRangeFromPoint(e.clientX, e.clientY);
                if (range) {
                    range.insertNode(draggedTable);
                }
            }
        });
    };

    const [fieldOptions, setFieldOptions] = useState([
        { label: 'Logo', display: '{Logo}', value: 'bill_file_id', times: 1, is_required: true, type: 'image' },
        {
            label: 'QR Image',
            display: '{QR Scan Img}',
            value: 'qr_file_url',
            times: 1,
            is_required: true,
            type: 'image'
        },
        {
            label: 'Customer Image',
            display: '{Customer Img}',
            value: 'customer_logo',
            times: 1,
            is_required: true,
            type: 'image'
        },
        {
            label: 'Item Image1',
            display: '{Image Item1}',
            value: 'loan_item1',
            times: 1,
            is_required: true,
            type: 'image'
        },
        {
            label: 'Item Image2',
            display: '{Image Item2}',
            value: 'loan_item2',
            times: 1,
            is_required: true,
            type: 'image'
        },
        {
            label: 'Item Image3',
            display: '{Image Item3}',
            value: 'loan_item3',
            times: 1,
            is_required: true,
            type: 'image'
        },
        { label: 'Business Name', display: '{BName}', value: 'bus_name', times: 1, is_required: true },
        { label: 'Business Address', display: '{BAddress}', value: 'bus_address', times: 1, is_required: true },
        { label: 'Business Contact', display: '{BContact}', value: 'bus_mobile_number', times: 1, is_required: true },
        { label: 'License Alias Name', display: '{LicAl}', value: 'license_alias_name', times: 1, is_required: true },
        { label: 'License Name', display: '{LicName}', value: 'license_name', times: 1, is_required: true },
        { label: 'License Number', display: '{LicNo}', value: 'license_number', times: 1, is_required: true },
        { label: 'Loan Date', display: '{LoanDate}', value: 'loan_date', times: 1, is_required: true },
        { label: 'Loan Number', display: '{LoNo}', value: 'loan_number', times: 1, is_required: true },
        { label: 'Scheme Alias Name', display: '{SchAl}', value: 'scheme_alias_name', times: 1, is_required: true },
        { label: 'Virtual Loan Number', display: '{VLoNo}', value: 'virtual_loan_number', times: 1, is_required: true },
        { label: 'Loan Amount', display: '{LoAmt}', value: 'loan_amount', times: 1, is_required: true },
        { label: 'S.No', display: '{SNo}', value: 'sno', times: 1, is_required: true },
        { label: 'Item Name', display: '{ItemName}', value: 'item_name', times: 1, is_required: true },
        { label: 'Gross Weight', display: '{GrossWeight}', value: 'item_gross_weight', times: 1, is_required: true },
        { label: 'Net Weight', display: '{NetWeight}', value: 'item_netweight', times: 1, is_required: true },
        {
            label: 'Total Gross Weight',
            display: '{TotalGrossWeight}',
            value: 'total_gross_weight',
            times: 1,
            is_required: true
        },
        {
            label: 'Total Net Weight',
            display: '{TotalNetWeight}',
            value: 'total_netweight',
            times: 1,
            is_required: true
        },
        { label: 'Common Remark', display: '{CommonRe}', value: 'common_remark', times: 1, is_required: true },
        {
            label: 'Amount In Words',
            display: '{Amount In Words}',
            value: 'loan_amount_in_words',
            times: 1,
            is_required: true
        },
        { label: 'Loan Items', display: '{LItems}', value: 'loan_items_in_words', times: 1, is_required: true },
        { label: 'Grams', display: '{Grams}', value: 'weight', times: 1, is_required: true },
        { label: 'Milligram', display: '{Mg}', value: 'milligram', times: 1, is_required: true },
        { label: 'Seal', display: '{Seal}', value: 'seal', times: 1, is_required: true },
        { label: 'P_Value', display: '{PValue}', value: 'p_value', times: 1, is_required: true },
        { label: 'Customer Name', display: '{CName}', value: 'cust_name', times: 1, is_required: true },
        { label: 'Customer ID', display: '{CstID}', value: 'cust_custom_id', times: 1, is_required: true },
        { label: 'Customer Care Of', display: '{COf}', value: 'cust_care_of', times: 1, is_required: true },
        { label: 'Customer Surname', display: '{CSurName}', value: 'cust_surname', times: 1, is_required: true },
        {
            label: 'Customer Profession',
            display: '{CProfession}',
            value: 'cust_profession',
            times: 1,
            is_required: true
        },
        { label: 'Customer Contact', display: '{CNo}', value: 'cust_mobile_number', times: 1, is_required: true },
        { label: 'Country Code', display: '{PC}', value: 'cust_phone_code', times: 1, is_required: true },
        { label: 'Address', display: '{CAddress}', value: 'address_one', times: 1, is_required: true },
        { label: 'Monthly Income', display: '{Income}', value: 'monthly_income', times: 1, is_required: true },
        { label: 'Quantity', display: '{Quantity}', value: 'quantity', times: 1, is_required: true },
        { label: 'Item Quantity', display: '{Item Quantity}', value: 'item_quantity', times: 1, is_required: true },
        { label: 'Total Quantity', display: '{TotalQuantity}', value: 'total_quantity', times: 1, is_required: true },
        {
            label: 'subtemplate ',
            display: '<!--subtemplate-->',
            value: 'subtemplate',
            times: 1,
            is_required: true
        },
        {
            label: '/subtemplate ',
            display: '<!--/subtemplate-->',
            value: '/subtemplate',
            times: 1,
            is_required: true
        }
    ]);

    const [isUpdatingStyles, setIsUpdatingStyles] = useState(false);

    const updateToolbarStyles = () => {
        if (isUpdatingStyles || !editorRef.current) return;

        setIsUpdatingStyles(true);

        const selection = window.getSelection();
        if (!selection || selection.rangeCount === 0) {
            setIsUpdatingStyles(false);
            return;
        }

        const range = selection.getRangeAt(0);
        if (!editorRef.current.contains(range.commonAncestorContainer)) {
            setIsUpdatingStyles(false);
            return;
        }

        // Get the container of the selection
        let container = range.startContainer;
        if (container.nodeType === Node.TEXT_NODE) {
            container = container.parentNode;
        }

        // Get computed styles
        const computedStyle = window.getComputedStyle(container);

        // Update font family
        const font = computedStyle.fontFamily.split(',')[0].replace(/['"]/g, '');
        if (fonts.includes(font)) setFontFamily(font);

        // Update font size
        const size = Math.round(parseFloat(computedStyle.fontSize));
        if (fontSizes.includes(size.toString())) setFontSize(size.toString());

        // Update text styles
        setIsBold(computedStyle.fontWeight === 'bold' || computedStyle.fontWeight === '700');
        setIsItalic(computedStyle.fontStyle === 'italic');
        setIsUnderline(computedStyle.textDecoration.includes('underline'));

        // Update text color
        setTextColor(computedStyle.color);

        // Update alignment
        let align = 'left';
        const textAlign = computedStyle.textAlign;
        if (textAlign === 'center') align = 'center';
        else if (textAlign === 'right') align = 'right';
        else if (textAlign === 'justify') align = 'full';
        setAlignment(align);

        setIsUpdatingStyles(false);
    };

    // Add these event listeners
    useEffect(() => {
        const handleMouseUp = () => {
            setTimeout(updateToolbarStyles, 10); // Small delay to ensure selection is updated
        };

        const handleKeyUp = () => {
            setTimeout(updateToolbarStyles, 10);
        };

        document.addEventListener('mouseup', handleMouseUp);
        document.addEventListener('keyup', handleKeyUp);

        return () => {
            document.removeEventListener('mouseup', handleMouseUp);
            document.removeEventListener('keyup', handleKeyUp);
        };
    }, []);

    return (
        <Modal open={open} onClose={onClose} aria-labelledby='modal-title' aria-describedby='modal-description'>
            <Box
                sx={{
                    '&::-webkit-scrollbar': {
                        display: 'none'
                    },
                    '-ms-overflow-style': 'none',
                    'scrollbar-width': 'none',
                    overflowY: 'auto',
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 3,
                    borderRadius: 2,
                    outline: 'none',
                    width: { xs: '100%', sm: '100%', md: '100%' },
                    height: 'auto',
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                <div
                    style={{
                        height: '100vh',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: '#f5f5f5',
                        overflow: 'none'
                    }}
                >
                    <AppBar position='static' color='default'>
                        <Toolbar>
                            <Box style={{ flexGrow: 1 }}>
                                <Button
                                    variant='contained'
                                    color='primary'
                                    startIcon={<ArrowBackOutlinedIcon />}
                                    onClick={onClose}
                                    size='small'
                                >
                                    Back
                                </Button>
                            </Box>
                            <ButtonGroup variant='text' style={{ marginRight: '10px' }}>
                                <Button
                                    variant='contained'
                                    color='primary'
                                    startIcon={<Save />}
                                    onClick={handleSave}
                                    size='small'
                                    disabled={isPreview}
                                >
                                    Save
                                </Button>
                                <Button
                                    variant='outlined'
                                    startIcon={<RotateLeftOutlinedIcon />}
                                    onClick={handleDialogOpen}
                                    size='small'
                                    disabled={isPreview}
                                >
                                    Reset
                                </Button>
                                <Dialog open={openAlertDialog} onClose={handleDialogClose}>
                                    <DialogTitle textAlign={'center'}>
                                        <ErrorOutlinedIcon sx={{ color: 'warning.main', fontSize: 50 }} />
                                        <Typography fontSize={20} fontWeight={600} color='primary'>
                                            Warning
                                        </Typography>
                                    </DialogTitle>
                                    <DialogContent>
                                        <Typography fontSize={16}>
                                            Are you sure you want to reset the receipt content? This will replace your
                                            current content with the default loan receipt specimen.
                                        </Typography>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleDialogClose} color='primary'>
                                            No
                                        </Button>
                                        <Button onClick={handleResetConfirm} color='primary'>
                                            Yes
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                                <Button
                                    variant='outlined'
                                    startIcon={<EditOutlinedIcon />}
                                    onClick={() => setShowConfirmModal(true)}
                                    size='small'
                                    disabled={isPreview === false}
                                >
                                    Edit
                                </Button>
                                <>
                                    <Dialog
                                        open={showConfirmModal}
                                        onClose={(event, reason) => {
                                            if (reason !== 'backdropClick') {
                                                setShowConfirmModal(false);
                                            }
                                        }}
                                    >
                                        <DialogTitle>​​Key Instructions </DialogTitle>
                                        <DialogContent>
                                            <Typography component='ul' sx={{ pl: 2 }}>
                                                <li>
                                                    You may customize the content as required within the available
                                                    screen layout.
                                                </li>
                                                <li>
                                                    Apply changes made in the Customer Copy section or Office Copy
                                                    section will be updated in respective sections.
                                                </li>
                                                <li>
                                                    If any changes are made incorrectly, use the Reset option to restore
                                                    the default specimen before making further modifications.
                                                </li>
                                                <li>To revert recent actions, use the Undo option (Ctrl + Z).</li>
                                                <li>
                                                    If you require a different loan receipt format, select a suitable
                                                    specimen and make required corrections within provided options.
                                                </li>
                                                <li>
                                                    Fields such as <b>P_Value</b>, <b>Seal</b>, <b>Customer Image</b>,
                                                    or <b>Jewel Image</b> are included in the receipt specimen but are
                                                    not available in the corresponding customer or loan records. Such
                                                    fields will either be displayed using a default image or left blank
                                                    in case of text fields, based on the field’s nature.
                                                </li>
                                                <li>
                                                    If you apply a style to only part of a variable, it won’t work
                                                    correctly and may show as plain text in the preview. For example, if
                                                    'Loan Number' is a variable and the style is applied only to 'Loan',
                                                    it may not work. So, please apply the style to the full variable.
                                                </li>
                                                <li>
                                                    Default template/specimen content will be shared separately and
                                                    should be integrated accordingly.
                                                </li>
                                                <li>
                                                    System must be flexible to load/update default templates as they
                                                    change in the future.
                                                </li>
                                                <li>
                                                    Ensure full multilingual support for all static and dynamic content
                                                    (Tamil/English/Tamil with English).
                                                </li>
                                            </Typography>
                                        </DialogContent>

                                        <DialogActions>
                                            <Button onClick={() => setShowConfirmModal(false)} color='primary'>
                                                No
                                            </Button>
                                            <Button
                                                onClick={() => {
                                                    setShowConfirmModal(false);
                                                    fetchTemplate();
                                                }}
                                                color='primary'
                                                autoFocus
                                            >
                                                Yes
                                            </Button>
                                        </DialogActions>
                                    </Dialog>
                                </>
                                {/* <Button
                                    variant='outlined'
                                    startIcon={<Upload />}
                                    onClick={triggerFileInput}
                                    size='small'
                                >
                                    Import
                                </Button>
                                <input
                                    type='file'
                                    ref={fileInputRef}
                                    onChange={handleImport}
                                    accept='.html,.htm'
                                    style={{ display: 'none' }}
                                /> */}
                            </ButtonGroup>
                        </Toolbar>
                    </AppBar>
                    <AppBar position='static' color='default' style={{ marginBottom: '10px' }}>
                        <Toolbar variant='dense' style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
                            <ButtonGroup variant='text' size='small' style={{ marginRight: '10px' }}>
                                <Button
                                    onClick={() => toggleFormat('bold')}
                                    color={isBold ? 'primary' : 'inherit'}
                                    title='Bold'
                                >
                                    <FormatBold />
                                </Button>
                                <Button
                                    onClick={() => toggleFormat('italic')}
                                    color={isItalic ? 'primary' : 'inherit'}
                                    title='Italic'
                                >
                                    <FormatItalic />
                                </Button>
                                {/* <Button
                                    onClick={() => toggleFormat('underline')}
                                    color={isUnderline ? 'primary' : 'inherit'}
                                    title='Underline'
                                >
                                    <FormatUnderlined />
                                </Button> */}
                                {/* <Button
                onClick={resetFormatting}
                title="Clear formatting"
              >
                <MdFormatColorReset />
              </Button> */}
                            </ButtonGroup>

                            <ButtonGroup variant='text' size='small' style={{ marginRight: '10px' }}>
                                <IconButton onClick={(e) => openColorPicker('text', e)} title='Text color' size='small'>
                                    <FormatColorText style={{ color: textColor }} />
                                </IconButton>
                                {/* <IconButton
                                    onClick={(e) => openColorPicker('highlight', e)}
                                    title='Highlight color'
                                    size='small'
                                >
                                    <FormatColorFill style={{ backgroundColor: highlightColor }} />
                                </IconButton> */}
                            </ButtonGroup>

                            <FormControl variant='standard' size='small' style={{ minWidth: 120, marginRight: '10px' }}>
                                <InputLabel>Font</InputLabel>
                                <Select value={fontFamily} onChange={handleFontChange}>
                                    {fonts.map((font) => (
                                        <MenuItem key={font} value={font}>
                                            {font}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl variant='standard' size='small' style={{ minWidth: 80, marginRight: '10px' }}>
                                <InputLabel>Size</InputLabel>
                                <Select value={fontSize} onChange={handleFontSizeChange}>
                                    {fontSizes.map((size) => (
                                        <MenuItem key={size} value={size}>
                                            {size}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <ButtonGroup variant='text' size='small' style={{ marginRight: '10px' }}>
                                <Button
                                    onClick={() => setTextAlignment('left')}
                                    color={alignment === 'left' ? 'primary' : 'inherit'}
                                    title='Align left'
                                >
                                    <FormatAlignLeft />
                                </Button>
                                <Button
                                    onClick={() => setTextAlignment('center')}
                                    color={alignment === 'center' ? 'primary' : 'inherit'}
                                    title='Align center'
                                >
                                    <FormatAlignCenter />
                                </Button>
                                <Button
                                    onClick={() => setTextAlignment('right')}
                                    color={alignment === 'right' ? 'primary' : 'inherit'}
                                    title='Align right'
                                >
                                    <FormatAlignRight />
                                </Button>
                                <Button
                                    onClick={() => setTextAlignment('full')}
                                    color={alignment === 'full' ? 'primary' : 'inherit'}
                                    title='Justify'
                                >
                                    <FormatAlignJustify />
                                </Button>
                            </ButtonGroup>

                            <ButtonGroup variant='text' size='small' style={{ marginRight: '10px' }}>
                                <Button onClick={() => createList('bullet')} title='Bullet list'>
                                    <FormatListBulleted />
                                </Button>
                                <Button onClick={() => createList('number')} title='Numbered list'>
                                    <FormatListNumbered />
                                </Button>
                                {/* <Button onClick={() => document.execCommand('formatBlock', false, '<p>')} title="Paragraph">
                <FaParagraph />
              </Button> */}
                            </ButtonGroup>

                            <ButtonGroup variant='text' size='small'>
                                <Button onClick={() => document.execCommand('undo', false, null)} title='Undo'>
                                    <Undo />
                                </Button>
                                <Button onClick={() => document.execCommand('redo', false, null)} title='Redo'>
                                    <Redo />
                                </Button>
                            </ButtonGroup>
                            {side !== 'back' && (
                                <FormControl
                                    variant='standard'
                                    size='small'
                                    style={{ minWidth: 120, marginLeft: '10px' }}
                                >
                                    <InputLabel>Insert Field</InputLabel>

                                    <Select
                                        value=''
                                        onChange={(e) => {
                                            const selectedOption = fieldOptions.find(
                                                (opt) => opt.value === e.target.value
                                            );
                                            if (selectedOption) {
                                                let html;

                                                if (selectedOption.type === 'image') {
                                                    let altText = '',
                                                        variable = '',
                                                        placeholderSrc = '',
                                                        imgWidth = '100px';

                                                    if (selectedOption.value === 'bill_file_id') {
                                                        altText = 'Logo';
                                                        variable = 'bill_file_id';
                                                        placeholderSrc =
                                                            'https://th.bing.com/th/id/OIP.rnxRsteNhrBigNjjHOQDagAAAA?rs=1&pid=ImgDetMain';
                                                        imgWidth = '100px';
                                                    } else if (selectedOption.value === 'qr_file_url') {
                                                        altText = 'QR Img';
                                                        variable = 'qr_file_url';
                                                        placeholderSrc =
                                                            'https://www.researchgate.net/publication/340398294/figure/fig3/AS:876175308103681@1585907880294/Sample-Figure-of-QR-Code-QR-code-works-in-a-simple-way-It-all-starts-of-by-feeding-in.ppm';
                                                        imgWidth = '90px';
                                                    } else if (selectedOption.value === 'customer_logo') {
                                                        altText = 'Customer Img';
                                                        variable = 'customer_logo';
                                                        placeholderSrc =
                                                            'https://static.vecteezy.com/system/resources/previews/005/544/718/non_2x/profile-icon-design-free-vector.jpg';
                                                        imgWidth = '90px';
                                                    } else if (selectedOption.value === 'loan_item1') {
                                                        altText = 'Item Img1';
                                                        variable = 'loan_item1';
                                                        placeholderSrc =
                                                            'https://tagtes-s3-b02.s3.ap-south-1.amazonaws.com/product/75001PBA/dev/e6b5a82e-05dc-40c3-b0ae-bdb6cf06c3cf.jpeg';
                                                        imgWidth = '90px';
                                                    } else if (selectedOption.value === 'loan_item2') {
                                                        altText = 'Item Img2';
                                                        variable = 'loan_item2';
                                                        placeholderSrc =
                                                            'https://tagtes-s3-b02.s3.ap-south-1.amazonaws.com/product/75001PBA/dev/115ba403-d08f-41ec-9743-07ddcf5457e8.jpeg';
                                                        imgWidth = '90px';
                                                    } else if (selectedOption.value === 'loan_item3') {
                                                        altText = 'Item Img3';
                                                        variable = 'loan_item3';
                                                        placeholderSrc =
                                                            'https://tagtes-s3-b02.s3.ap-south-1.amazonaws.com/product/75001PBA/dev/c70472d5-6a92-41d1-8623-cc6e4c31bfa6.jpeg';
                                                        imgWidth = '90px';
                                                    }
                                                    html = `<img data-variable="${variable}" src="${placeholderSrc}" alt="${altText}" style="max-width: ${imgWidth}; font-size:12px" data-src="{{${variable}}}"/>`;
                                                } else {
                                                    html = `&nbsp;<span data-variable="${selectedOption.value}" style="font-weight:bold">${selectedOption.display}</span>&nbsp;`;
                                                }

                                                document.execCommand('insertHTML', false, html);
                                                e.target.value = '';
                                                setFieldUsage(countFieldUsage());
                                            }
                                        }}
                                        label='Insert Field'
                                    >
                                        <MenuItem value=''>
                                            <em>Select a field</em>
                                        </MenuItem>

                                        {fieldOptions
                                            .filter((option) => {
                                                const generalHidden = [
                                                    'customer_logo',
                                                    'loan_item1',
                                                    'loan_item2',
                                                    'loan_item3'
                                                ];
                                                const customerImageHidden = ['loan_item1', 'loan_item2', 'loan_item3'];

                                                if (billType === 'general' && generalHidden.includes(option.value)) {
                                                    return false;
                                                }

                                                if (
                                                    billType === 'customer_image' &&
                                                    customerImageHidden.includes(option.value)
                                                ) {
                                                    return false;
                                                }
                                                if (['subtemplate', '/subtemplate'].includes(option.value)) {
                                                    return false;
                                                }
                                                if (
                                                    paperType !== 'customer_with_item_image_article_type2' &&
                                                    [
                                                        'item_quantity',
                                                        'sno',
                                                        'item_name',
                                                        'item_gross_weight',
                                                        'item_netweight',
                                                        'total_gross_weight',
                                                        'total_netweight',
                                                        'total_quantity'
                                                    ].includes(option.value)
                                                ) {
                                                    return false;
                                                }
                                                if (
                                                    paperType === 'customer_with_item_image_article_type2' &&
                                                    ['quantity', 'loan_items'].includes(option.value)
                                                ) {
                                                    return false;
                                                }

                                                // billType === 'customer_with_item_image' → show all
                                                return true;
                                            })
                                            .map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <b>{option.label}</b>&nbsp;=&nbsp;{option.display}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            )}

                            {/* <Button onClick={() => setShowTableDialog(true)} title="Insert table">
              <TableChart />
              <span style={{ marginLeft: '5px' }}>Table</span>
            </Button>

            <ButtonGroup variant="text" size="small" style={{ marginRight: '10px' }}>
            <Button
              onClick={toggleOrientation}
              title={pageOrientation === 'portrait' ? 'Switch to landscape' : 'Switch to portrait'}
            >
              {pageOrientation === 'portrait' ? <MdLandscape /> : <MdPortrait />}
              <span style={{ marginLeft: '5px' }}>
                {pageOrientation === 'portrait' ? 'Landscape' : 'Portrait'}
              </span>
            </Button>
            <Button
              onClick={() => setShowPageSetup(true)}
              title="Page setup"
            >
              <Settings />
              <span style={{ marginLeft: '5px' }}>Page Setup</span>
            </Button>
            </ButtonGroup> */}
                        </Toolbar>
                    </AppBar>
                    <Box display='flex' justifyContent='center'>
                        {['customer_with_item_image_article_type1', 'customer_with_item_image_article_type2'].includes(
                            paperType
                        ) &&
                            !officeCopy && (
                                <Grid item xs={12} sm={6}>
                                    <Box display='flex' justifyContent='center' alignItems='center'>
                                        <Typography>Customer Copy</Typography>
                                    </Box>
                                </Grid>
                            )}
                        {['customer_with_item_image_article_type1', 'customer_with_item_image_article_type2'].includes(
                            paperType
                        ) &&
                            officeCopy && (
                                <Grid item xs={12} sm={6}>
                                    <Box display='flex' justifyContent='center' alignItems='center'>
                                        <Typography>Office Copy</Typography>
                                    </Box>
                                </Grid>
                            )}
                        {!['customer_with_item_image_article_type1', 'customer_with_item_image_article_type2'].includes(
                            paperType
                        ) && (
                            <Grid container maxWidth='md' spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <Box display='flex' justifyContent='center' alignItems='center'>
                                        <Typography>Office Copy</Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Box display='flex' justifyContent='center' alignItems='center'>
                                        <Typography>Customer Copy</Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                        )}
                    </Box>

                    <Box
                        sx={{
                            flexGrow: 1,
                            padding: '20px',
                            overflow: 'auto',
                            // display: 'flex',
                            // justifyContent: 'center',
                            backgroundColor: '#e0e0e0',
                            position: 'relative',
                            transformOrigin: 'center center'
                        }}
                    >
                        <Box
                            sx={{
                                width: pageOrientation === 'portrait' ? `${a4WidthPx}px` : `${a4HeightPx}px`,
                                minHeight: pageOrientation === 'portrait' ? `${a4HeightPx}px` : `${a4WidthPx}px`,
                                backgroundColor: 'white',
                                boxShadow: '0 0 10px rgba(0,0,0,0.2)',
                                padding: `${pageMargins.top} ${pageMargins.right} ${pageMargins.bottom} ${pageMargins.left}`,
                                boxSizing: 'border-box',
                                position: 'relative',
                                // overflow: 'hidden'
                                mx: 'auto',
                                pointerEvents: isPreview ? 'none' : ''
                            }}
                        >
                            <div
                                ref={editorRef}
                                contentEditable
                                style={{
                                    minHeight: '100%',
                                    outline: 'none',
                                    height: '100%',
                                    overflow: 'auto',
                                    position: 'relative'
                                }}
                                onClick={updateToolbarStyles}
                                onKeyUp={updateToolbarStyles}
                            ></div>
                        </Box>
                    </Box>
                    {/* Overflow Alert */}
                    <Dialog
                        sx={{ display: isPreview ? 'none' : '' }}
                        open={overflowAlert}
                        onClose={() => {
                            setOverflowAlert(false);
                            if (!isPreview) {
                                document.execCommand('undo', false, null);
                            }
                        }}
                    >
                        <DialogTitle textAlign={'center'}>
                            {!isPreview ? (
                                <ErrorOutlinedIcon sx={{ color: 'warning.main', fontSize: 50 }} />
                            ) : (
                                <CheckCircleIcon sx={{ color: 'success.main', fontSize: 50 }} />
                            )}
                            <Typography fontSize={20} fontWeight={600} color='primary'>
                                {!isPreview ? 'Warning' : 'Saved'}
                            </Typography>
                        </DialogTitle>
                        <DialogContent>
                            <Typography fontSize={16}>
                                {!isPreview
                                    ? 'Your content exceeds the page height! Some content may not be visible when printed or exported.'
                                    : 'Your content has been saved'}
                            </Typography>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => {
                                    setOverflowAlert(false);
                                    if (!isPreview) {
                                        document.execCommand('undo', false, null);
                                    }
                                }}
                                color='primary'
                            >
                                OK
                            </Button>
                        </DialogActions>
                    </Dialog>
                    {/* Table Insert Dialog */}
                    <Dialog open={showTableDialog} onClose={() => setShowTableDialog(false)} maxWidth='sm' fullWidth>
                        <DialogTitle>
                            Insert Table
                            <IconButton
                                aria-label='close'
                                onClick={() => setShowTableDialog(false)}
                                sx={{
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                    color: (theme) => theme.palette.grey[500]
                                }}
                            >
                                <Close />
                            </IconButton>
                        </DialogTitle>
                        <DialogContent>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 2 }}>
                                <Box sx={{ display: 'flex', gap: 2 }}>
                                    <TextField
                                        label='Rows'
                                        type='number'
                                        fullWidth
                                        value={rows}
                                        onChange={(e) => setRows(Math.max(1, parseInt(e.target.value) || 1))}
                                        inputProps={{ min: 1, max: 20 }}
                                    />
                                    <TextField
                                        label='Columns'
                                        type='number'
                                        fullWidth
                                        value={cols}
                                        onChange={(e) => setCols(Math.max(1, parseInt(e.target.value) || 1))}
                                        inputProps={{ min: 1, max: 20 }}
                                    />
                                </Box>
                                <Box sx={{ display: 'flex', gap: 2 }}>
                                    <TextField
                                        label='Border Size (px)'
                                        type='number'
                                        fullWidth
                                        value={tableBorder}
                                        onChange={(e) => setTableBorder(Math.max(0, parseInt(e.target.value) || 0))}
                                        inputProps={{ min: 0, max: 10 }}
                                    />
                                </Box>
                                <Box
                                    sx={{
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(auto-fill, minmax(40px, 1fr))',
                                        gap: 1,
                                        mt: 2
                                    }}
                                >
                                    {Array.from({ length: 5 }, (_, i) => i + 1).map((row) =>
                                        Array.from({ length: 5 }, (_, j) => j + 1).map((col) => (
                                            <Box
                                                key={`${row}-${col}`}
                                                onClick={() => {
                                                    setRows(row);
                                                    setCols(col);
                                                }}
                                                sx={{
                                                    width: '100%',
                                                    height: '40px',
                                                    border: '1px solid #ccc',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    cursor: 'pointer',
                                                    backgroundColor:
                                                        rows === row && cols === col ? '#e0e0e0' : 'transparent',
                                                    '&:hover': {
                                                        backgroundColor: '#f0f0f0'
                                                    }
                                                }}
                                            >
                                                {row}x{col}
                                            </Box>
                                        ))
                                    )}
                                </Box>
                            </Box>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setShowTableDialog(false)}>Cancel</Button>
                            <Button onClick={insertTable} variant='contained'>
                                Insert Table
                            </Button>
                        </DialogActions>
                    </Dialog>
                    {/* Page Setup Dialog */}
                    <Dialog open={showPageSetup} onClose={() => setShowPageSetup(false)}>
                        <DialogTitle>Page Setup</DialogTitle>
                        <DialogContent>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    <TextField
                                        label='Top Margin'
                                        value={pageMargins.top}
                                        onChange={(e) => setPageMargins({ ...pageMargins, top: e.target.value })}
                                    />
                                    <TextField
                                        label='Bottom Margin'
                                        value={pageMargins.bottom}
                                        onChange={(e) => setPageMargins({ ...pageMargins, bottom: e.target.value })}
                                    />
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    <TextField
                                        label='Left Margin'
                                        value={pageMargins.left}
                                        onChange={(e) => setPageMargins({ ...pageMargins, left: e.target.value })}
                                    />
                                    <TextField
                                        label='Right Margin'
                                        value={pageMargins.right}
                                        onChange={(e) => setPageMargins({ ...pageMargins, right: e.target.value })}
                                    />
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    <Button
                                        variant={pageOrientation === 'portrait' ? 'contained' : 'outlined'}
                                        onClick={() => setPageOrientation('portrait')}
                                        // startIcon={<MdPortrait />}
                                    >
                                        Portrait
                                    </Button>
                                    <Button
                                        variant={pageOrientation === 'landscape' ? 'contained' : 'outlined'}
                                        onClick={() => setPageOrientation('landscape')}
                                        // startIcon={<MdLandscape />}
                                    >
                                        Landscape
                                    </Button>
                                </Box>
                            </Box>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setShowPageSetup(false)}>Cancel</Button>
                            <Button onClick={() => setShowPageSetup(false)} color='primary'>
                                Apply
                            </Button>
                        </DialogActions>
                    </Dialog>
                    {/* Color Picker Popover */}
                    <Popover
                        open={Boolean(colorPickerAnchor)}
                        anchorEl={colorPickerAnchor}
                        onClose={closeColorPicker}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left'
                        }}
                        disableRestoreFocus
                        onMouseDown={(e) => e.preventDefault()}
                    >
                        <div onMouseDown={(e) => e.preventDefault()}>
                            <ChromePicker
                                color={currentColorType === 'text' ? textColor : highlightColor}
                                onChange={handleColorChange}
                                onChangeComplete={handleColorChange}
                                disableAlpha
                            />
                        </div>
                    </Popover>
                </div>
            </Box>
        </Modal>
    );
}

export default App;
